import { render } from "./ViewCourse.vue?vue&type=template&id=df75dc5a"
import script from "./ViewCourse.vue?vue&type=script&lang=js"
export * from "./ViewCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__